import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import {
    selectRecommendations,
} from '~Betslip/selectors/recommendationsSelectors';

import {
    selectExpandedRecommendations,
} from '~Betslip/selectors/preferencesSelectors';

import {
    setExpandedRecommendations as setReceiptRecommendationsExpanded,
} from '~Betslip/slices/preferencesSlice';

import {
    selectShowBetReceipt,
} from '~Betslip/selectors/betReceiptSelectors';

import RecommendationSelection from './RecommendationSelection';

import './styles.scss';

const Recommendations = () => {
    const [ t ] = useTranslation();
    const recommendations = useSelector(selectRecommendations);
    const showBetReceipt = useSelector(selectShowBetReceipt);
    const receiptRecommendationsExpanded = useSelector(selectExpandedRecommendations);
    const dispatch = useDispatch();

    // Recommendations should be collapsed by default on betslip
    const [
        bSRecommendationsExpanded,
        setBSRecommendationsExpanded,
    ] = useState(false);

    if (recommendations.length <= 0) {
        return null;
    }

    const recommendationsAreExpanded = showBetReceipt
        ? receiptRecommendationsExpanded
        : bSRecommendationsExpanded;

    const setRecommendationsExpanded = (val) => {
        if (showBetReceipt) {
            dispatch(setReceiptRecommendationsExpanded(val));
        } else {
            setBSRecommendationsExpanded(val);
        }
    };

    const recommendationsListClasses = classNames('fullslip__recommendations-list', {
        'fullslip__recommendations-list--hidden': !recommendationsAreExpanded,
    });

    const arrowIconClasses = classNames('fullslip__recommendations-dropdown-icon', {
        'fullslip__recommendations-dropdown-icon--expanded': recommendationsAreExpanded,
    });

    const gtmExpanderState = recommendationsAreExpanded ? 'collapse' : 'expand';
    const gtmRecommendationsPrefix = showBetReceipt ? 'betreceipt' : 'betslip';
    const gtmRecommendationsLocation = `${gtmRecommendationsPrefix};recommendations;`;

    return (
        <>
            <div
                className="fullslip__recommendations-header"
                onClick={() => setRecommendationsExpanded(!recommendationsAreExpanded)}
                data-spectate-product={`${gtmRecommendationsLocation}${gtmExpanderState}`}
            >
                <span className="fullslip__recommendations-hand-icon"></span>
                <span className="fullslip__recommendations-header-text">
                    {t('bs_recommends.title_text_default')}
                </span>
                <span className={arrowIconClasses}></span>
            </div>
            <ul
                className={recommendationsListClasses}
                data-ga_component="recommendations_v1_betslip"
            >
                {
                    recommendations.map(recommendation => {
                        return <RecommendationSelection
                            key={recommendation.id}
                            recommendation={recommendation}
                            gtmAttribute={gtmRecommendationsLocation}
                        />;
                    })
                }
            </ul>
        </>
    );
};

export default Recommendations;
